var map = {
	"./": 22974,
	"./App": 17391,
	"./App.css": 44050,
	"./App.test": 20477,
	"./App.test.tsx": 20477,
	"./App.tsx": 17391,
	"./assets/fonts/Montserrat-Bold.ttf": 72346,
	"./assets/fonts/Montserrat-Regular.ttf": 6809,
	"./assets/img/close.png": 23474,
	"./assets/img/close_button.png": 83795,
	"./assets/img/cruz-diez-logo.png": 48465,
	"./assets/img/gradient.png": 21300,
	"./assets/img/icons/arrow-down.png": 87649,
	"./assets/img/icons/arrow-up.png": 33874,
	"./assets/img/icons/demo.png": 45444,
	"./assets/img/icons/print-cross.png": 83451,
	"./assets/img/icons/print.png": 41484,
	"./assets/img/icons/qrcode.png": 25443,
	"./assets/img/icons/reset.svg": 49948,
	"./assets/img/icons/rotate-left.svg": 17868,
	"./assets/img/icons/rotate-right.svg": 70419,
	"./assets/img/icons/settings.svg": 9468,
	"./assets/img/icons/share-second.png": 15195,
	"./assets/img/icons/share.png": 50472,
	"./assets/img/icons/stripe-select.png": 54629,
	"./assets/img/icons/stripeWidth/stripeWidth1.svg": 70877,
	"./assets/img/icons/stripeWidth/stripeWidth2.svg": 42430,
	"./assets/img/icons/stripeWidth/stripeWidth3.svg": 21359,
	"./assets/img/icons/stripeWidth/stripeWidth4.svg": 3888,
	"./assets/img/icons/stripeWidth/stripeWidth5.svg": 2337,
	"./assets/img/intro/logo-left.png": 39880,
	"./assets/img/intro/logo-right.png": 70333,
	"./assets/img/restart.png": 40679,
	"./assets/img/shapes/circle-small.svg": 92445,
	"./assets/img/shapes/circle.svg": 49119,
	"./assets/img/shapes/ellipse-small.svg": 27805,
	"./assets/img/shapes/ellipse.svg": 4415,
	"./assets/img/shapes/hidden.png": 85847,
	"./assets/img/shapes/hiddenBeforeCompress.png": 7962,
	"./assets/img/shapes/inverted-triangle-small.svg": 9047,
	"./assets/img/shapes/inverted-triangle.svg": 45973,
	"./assets/img/shapes/rectangle-small.svg": 89284,
	"./assets/img/shapes/rectangle.svg": 37534,
	"./assets/img/shapes/rhombus-small.svg": 53739,
	"./assets/img/shapes/rhombus.svg": 16985,
	"./assets/img/shapes/square-small.svg": 24116,
	"./assets/img/shapes/square.svg": 63022,
	"./assets/img/shapes/triangle-small.svg": 76369,
	"./assets/img/shapes/triangle.svg": 35651,
	"./assets/img/spectrum-no-shadow-no-compress.png": 36141,
	"./assets/img/spectrum-no-shadow.png": 80560,
	"./assets/img/spectrum.png": 97677,
	"./assets/lotties/CruzDiezIntro": 37928,
	"./assets/lotties/CruzDiezIntro.json": 37928,
	"./assets/lotties/CruzDiezIntroWithoutText": 81323,
	"./assets/lotties/CruzDiezIntroWithoutText.json": 81323,
	"./components/Background": 44505,
	"./components/Background.test": 54363,
	"./components/Background.test.tsx": 54363,
	"./components/Background.tsx": 44505,
	"./components/Bottom/Footer/Footer": 14496,
	"./components/Bottom/Footer/Footer.css": 38397,
	"./components/Bottom/Footer/Footer.tsx": 14496,
	"./components/Bottom/Footer/IFooterParams": 44467,
	"./components/Bottom/Footer/IFooterParams.tsx": 44467,
	"./components/Bottom/Footer/delegate": 7528,
	"./components/Bottom/Footer/delegate.test": 41252,
	"./components/Bottom/Footer/delegate.test.ts": 41252,
	"./components/Bottom/Footer/delegate.ts": 7528,
	"./components/Bottom/FooterIcon/FooterIcon": 37178,
	"./components/Bottom/FooterIcon/FooterIcon.tsx": 37178,
	"./components/Bottom/FooterIcon/IFooterIconParams": 8055,
	"./components/Bottom/FooterIcon/IFooterIconParams.tsx": 8055,
	"./components/Bottom/RotateButton/IRotateButtonParams": 60803,
	"./components/Bottom/RotateButton/IRotateButtonParams.tsx": 60803,
	"./components/Bottom/RotateButton/RotateButton": 44976,
	"./components/Bottom/RotateButton/RotateButton.css": 42769,
	"./components/Bottom/RotateButton/RotateButton.tsx": 44976,
	"./components/Bottom/SelectShapeButton/DynamicSVG": 73948,
	"./components/Bottom/SelectShapeButton/DynamicSVG.css": 80163,
	"./components/Bottom/SelectShapeButton/DynamicSVG.tsx": 73948,
	"./components/Bottom/SelectShapeButton/ISelectShapeButtonParams": 24837,
	"./components/Bottom/SelectShapeButton/ISelectShapeButtonParams.tsx": 24837,
	"./components/Bottom/SelectShapeButton/SelectShapeButton": 70216,
	"./components/Bottom/SelectShapeButton/SelectShapeButton.css": 85209,
	"./components/Bottom/SelectShapeButton/SelectShapeButton.tsx": 70216,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Circle": 75774,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Circle.tsx": 75774,
	"./components/Bottom/SelectShapeButton/ShapeComponents/CircleSmall": 81704,
	"./components/Bottom/SelectShapeButton/ShapeComponents/CircleSmall.tsx": 81704,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Ellipse": 8131,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Ellipse.tsx": 8131,
	"./components/Bottom/SelectShapeButton/ShapeComponents/EllipseSmall": 42714,
	"./components/Bottom/SelectShapeButton/ShapeComponents/EllipseSmall.tsx": 42714,
	"./components/Bottom/SelectShapeButton/ShapeComponents/InvertedTriangle": 40018,
	"./components/Bottom/SelectShapeButton/ShapeComponents/InvertedTriangle.tsx": 40018,
	"./components/Bottom/SelectShapeButton/ShapeComponents/InvertedTriangleSmall": 41541,
	"./components/Bottom/SelectShapeButton/ShapeComponents/InvertedTriangleSmall.tsx": 41541,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Rectangle": 81974,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Rectangle.tsx": 81974,
	"./components/Bottom/SelectShapeButton/ShapeComponents/RectangleSmall": 84937,
	"./components/Bottom/SelectShapeButton/ShapeComponents/RectangleSmall.tsx": 84937,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Rhombus": 84613,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Rhombus.tsx": 84613,
	"./components/Bottom/SelectShapeButton/ShapeComponents/RhombusSmall": 79756,
	"./components/Bottom/SelectShapeButton/ShapeComponents/RhombusSmall.tsx": 79756,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Square": 18304,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Square.tsx": 18304,
	"./components/Bottom/SelectShapeButton/ShapeComponents/SquareSmall": 99139,
	"./components/Bottom/SelectShapeButton/ShapeComponents/SquareSmall.tsx": 99139,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Triangle": 72065,
	"./components/Bottom/SelectShapeButton/ShapeComponents/Triangle.tsx": 72065,
	"./components/Bottom/SelectShapeButton/ShapeComponents/TriangleSmall": 17816,
	"./components/Bottom/SelectShapeButton/ShapeComponents/TriangleSmall.tsx": 17816,
	"./components/Bottom/StripeButton/IStripeButtonParams": 10975,
	"./components/Bottom/StripeButton/IStripeButtonParams.tsx": 10975,
	"./components/Bottom/StripeButton/StripeButton": 25952,
	"./components/Bottom/StripeButton/StripeButton.css": 6825,
	"./components/Bottom/StripeButton/StripeButton.tsx": 25952,
	"./components/Bottom/WidthButton/IWidthButtonParams": 37475,
	"./components/Bottom/WidthButton/IWidthButtonParams.tsx": 37475,
	"./components/Bottom/WidthButton/WidthButton": 10648,
	"./components/Bottom/WidthButton/WidthButton.tsx": 10648,
	"./components/Color": 84236,
	"./components/Color.tsx": 84236,
	"./components/DemoInstructions/DemoInstructions": 45634,
	"./components/DemoInstructions/DemoInstructions.css": 71709,
	"./components/DemoInstructions/DemoInstructions.tsx": 45634,
	"./components/DemoInstructions/IDemoInstructionsParams": 71235,
	"./components/DemoInstructions/IDemoInstructionsParams.tsx": 71235,
	"./components/Figure": 92669,
	"./components/Figure.tsx": 92669,
	"./components/FigureDownload": 37685,
	"./components/FigureDownload.tsx": 37685,
	"./components/IIntroParams": 82270,
	"./components/IIntroParams.tsx": 82270,
	"./components/IVizualizationDownloadParams": 68453,
	"./components/IVizualizationDownloadParams.tsx": 68453,
	"./components/IVizualizationParams": 87733,
	"./components/IVizualizationParams.tsx": 87733,
	"./components/Intro": 37503,
	"./components/Intro.css": 13792,
	"./components/Intro.tsx": 37503,
	"./components/LanguageSwitcher/LanguageSwitcher": 34888,
	"./components/LanguageSwitcher/LanguageSwitcher.css": 5971,
	"./components/LanguageSwitcher/LanguageSwitcher.tsx": 34888,
	"./components/Left/ColorButtonPalette/ColorButtonPalette": 23884,
	"./components/Left/ColorButtonPalette/ColorButtonPalette.css": 40057,
	"./components/Left/ColorButtonPalette/ColorButtonPalette.tsx": 23884,
	"./components/Left/ColorButtonPalette/IColorButtonPaletteParams": 33157,
	"./components/Left/ColorButtonPalette/IColorButtonPaletteParams.tsx": 33157,
	"./components/Left/CustomColorInput/CustomColorInput": 66700,
	"./components/Left/CustomColorInput/CustomColorInput.css": 13453,
	"./components/Left/CustomColorInput/CustomColorInput.tsx": 66700,
	"./components/MoreTimePopUp/IMoreTimePopUpParams": 58267,
	"./components/MoreTimePopUp/IMoreTimePopUpParams.tsx": 58267,
	"./components/MoreTimePopUp/MoreTimePopUp": 8820,
	"./components/MoreTimePopUp/MoreTimePopUp.css": 88335,
	"./components/MoreTimePopUp/MoreTimePopUp.tsx": 8820,
	"./components/Palette": 53684,
	"./components/Palette.tsx": 53684,
	"./components/PlaceOfSignature": 93249,
	"./components/PlaceOfSignature.tsx": 93249,
	"./components/QrCode": 31107,
	"./components/QrCode.css": 7226,
	"./components/QrCode.tsx": 31107,
	"./components/Right/ShapeButtonPalette/IShapeButtonPaletteParams": 51382,
	"./components/Right/ShapeButtonPalette/IShapeButtonPaletteParams.tsx": 51382,
	"./components/Right/ShapeButtonPalette/ShapeButtonPalette": 74421,
	"./components/Right/ShapeButtonPalette/ShapeButtonPalette.css": 61646,
	"./components/Right/ShapeButtonPalette/ShapeButtonPalette.tsx": 74421,
	"./components/SettingsPopUp/ISettingsPopUpParams": 47821,
	"./components/SettingsPopUp/ISettingsPopUpParams.tsx": 47821,
	"./components/SettingsPopUp/SettingsPopUp": 64756,
	"./components/SettingsPopUp/SettingsPopUp.css": 93743,
	"./components/SettingsPopUp/SettingsPopUp.tsx": 64756,
	"./components/Shape": 62426,
	"./components/Shape.tsx": 62426,
	"./components/ShapeColors": 1714,
	"./components/ShapeColors.tsx": 1714,
	"./components/ShapePosition": 84559,
	"./components/ShapePosition.tsx": 84559,
	"./components/Shapes": 9927,
	"./components/Shapes.tsx": 9927,
	"./components/Shapes/0.2/CircleSmall_02": 6345,
	"./components/Shapes/0.2/CircleSmall_02.tsx": 6345,
	"./components/Shapes/0.2/Circle_02": 45526,
	"./components/Shapes/0.2/Circle_02.tsx": 45526,
	"./components/Shapes/0.2/EllipseSmall_02": 13291,
	"./components/Shapes/0.2/EllipseSmall_02.tsx": 13291,
	"./components/Shapes/0.2/Ellipse_02": 22595,
	"./components/Shapes/0.2/Ellipse_02.tsx": 22595,
	"./components/Shapes/0.2/InvertedTriangleSmall_02": 38414,
	"./components/Shapes/0.2/InvertedTriangleSmall_02.tsx": 38414,
	"./components/Shapes/0.2/InvertedTriangle_02": 68051,
	"./components/Shapes/0.2/InvertedTriangle_02.tsx": 68051,
	"./components/Shapes/0.2/RectangleSmall_02": 48046,
	"./components/Shapes/0.2/RectangleSmall_02.tsx": 48046,
	"./components/Shapes/0.2/Rectangle_02": 53235,
	"./components/Shapes/0.2/Rectangle_02.tsx": 53235,
	"./components/Shapes/0.2/RhombusSmall_02": 71717,
	"./components/Shapes/0.2/RhombusSmall_02.tsx": 71717,
	"./components/Shapes/0.2/Rhombus_02": 6290,
	"./components/Shapes/0.2/Rhombus_02.tsx": 6290,
	"./components/Shapes/0.2/SquareSmall_02": 68432,
	"./components/Shapes/0.2/SquareSmall_02.tsx": 68432,
	"./components/Shapes/0.2/Square_02": 53333,
	"./components/Shapes/0.2/Square_02.tsx": 53333,
	"./components/Shapes/0.2/TriangleSmall_02": 84473,
	"./components/Shapes/0.2/TriangleSmall_02.tsx": 84473,
	"./components/Shapes/0.2/Triangle_02": 83910,
	"./components/Shapes/0.2/Triangle_02.tsx": 83910,
	"./components/Shapes/0.5/CircleSmall_05": 16651,
	"./components/Shapes/0.5/CircleSmall_05.tsx": 16651,
	"./components/Shapes/0.5/Circle_05": 76638,
	"./components/Shapes/0.5/Circle_05.tsx": 76638,
	"./components/Shapes/0.5/EllipseSmall_05": 97439,
	"./components/Shapes/0.5/EllipseSmall_05.tsx": 97439,
	"./components/Shapes/0.5/Ellipse_05": 51394,
	"./components/Shapes/0.5/Ellipse_05.tsx": 51394,
	"./components/Shapes/0.5/InvertedTriangleSmall_05": 50240,
	"./components/Shapes/0.5/InvertedTriangleSmall_05.tsx": 50240,
	"./components/Shapes/0.5/InvertedTriangle_05": 24571,
	"./components/Shapes/0.5/InvertedTriangle_05.tsx": 24571,
	"./components/Shapes/0.5/RectangleSmall_05": 90642,
	"./components/Shapes/0.5/RectangleSmall_05.tsx": 90642,
	"./components/Shapes/0.5/Rectangle_05": 19893,
	"./components/Shapes/0.5/Rectangle_05.tsx": 19893,
	"./components/Shapes/0.5/RhombusSmall_05": 32269,
	"./components/Shapes/0.5/RhombusSmall_05.tsx": 32269,
	"./components/Shapes/0.5/Rhombus_05": 11776,
	"./components/Shapes/0.5/Rhombus_05.tsx": 11776,
	"./components/Shapes/0.5/SquareSmall_05": 26454,
	"./components/Shapes/0.5/SquareSmall_05.tsx": 26454,
	"./components/Shapes/0.5/Square_05": 32585,
	"./components/Shapes/0.5/Square_05.tsx": 32585,
	"./components/Shapes/0.5/TriangleSmall_05": 9935,
	"./components/Shapes/0.5/TriangleSmall_05.tsx": 9935,
	"./components/Shapes/0.5/Triangle_05": 50706,
	"./components/Shapes/0.5/Triangle_05.tsx": 50706,
	"./components/Shapes/0.8/CircleSmall_08": 49341,
	"./components/Shapes/0.8/CircleSmall_08.tsx": 49341,
	"./components/Shapes/0.8/Circle_08": 2806,
	"./components/Shapes/0.8/Circle_08.tsx": 2806,
	"./components/Shapes/0.8/EllipseSmall_08": 30711,
	"./components/Shapes/0.8/EllipseSmall_08.tsx": 30711,
	"./components/Shapes/0.8/Ellipse_08": 1904,
	"./components/Shapes/0.8/Ellipse_08.tsx": 1904,
	"./components/Shapes/0.8/InvertedTriangleSmall_08": 90786,
	"./components/Shapes/0.8/InvertedTriangleSmall_08.tsx": 90786,
	"./components/Shapes/0.8/InvertedTriangle_08": 5679,
	"./components/Shapes/0.8/InvertedTriangle_08.tsx": 5679,
	"./components/Shapes/0.8/RectangleSmall_08": 83814,
	"./components/Shapes/0.8/RectangleSmall_08.tsx": 83814,
	"./components/Shapes/0.8/Rectangle_08": 7715,
	"./components/Shapes/0.8/Rectangle_08.tsx": 7715,
	"./components/Shapes/0.8/RhombusSmall_08": 88961,
	"./components/Shapes/0.8/RhombusSmall_08.tsx": 88961,
	"./components/Shapes/0.8/Rhombus_08": 17242,
	"./components/Shapes/0.8/Rhombus_08.tsx": 17242,
	"./components/Shapes/0.8/SquareSmall_08": 47784,
	"./components/Shapes/0.8/SquareSmall_08.tsx": 47784,
	"./components/Shapes/0.8/Square_08": 64389,
	"./components/Shapes/0.8/Square_08.tsx": 64389,
	"./components/Shapes/0.8/TriangleSmall_08": 27877,
	"./components/Shapes/0.8/TriangleSmall_08.tsx": 27877,
	"./components/Shapes/0.8/Triangle_08": 30718,
	"./components/Shapes/0.8/Triangle_08.tsx": 30718,
	"./components/Shapes/1.5/CircleSmall_15": 65467,
	"./components/Shapes/1.5/CircleSmall_15.tsx": 65467,
	"./components/Shapes/1.5/Circle_15": 34648,
	"./components/Shapes/1.5/Circle_15.tsx": 34648,
	"./components/Shapes/1.5/EllipseSmall_15": 82133,
	"./components/Shapes/1.5/EllipseSmall_15.tsx": 82133,
	"./components/Shapes/1.5/Ellipse_15": 84218,
	"./components/Shapes/1.5/Ellipse_15.tsx": 84218,
	"./components/Shapes/1.5/InvertedTriangleSmall_15": 28396,
	"./components/Shapes/1.5/InvertedTriangleSmall_15.tsx": 28396,
	"./components/Shapes/1.5/InvertedTriangle_15": 75997,
	"./components/Shapes/1.5/InvertedTriangle_15.tsx": 75997,
	"./components/Shapes/1.5/RectangleSmall_15": 80008,
	"./components/Shapes/1.5/RectangleSmall_15.tsx": 80008,
	"./components/Shapes/1.5/Rectangle_15": 28473,
	"./components/Shapes/1.5/Rectangle_15.tsx": 28473,
	"./components/Shapes/1.5/RhombusSmall_15": 85271,
	"./components/Shapes/1.5/RhombusSmall_15.tsx": 85271,
	"./components/Shapes/1.5/Rhombus_15": 73236,
	"./components/Shapes/1.5/Rhombus_15.tsx": 73236,
	"./components/Shapes/1.5/SquareSmall_15": 25890,
	"./components/Shapes/1.5/SquareSmall_15.tsx": 25890,
	"./components/Shapes/1.5/Square_15": 9139,
	"./components/Shapes/1.5/Square_15.tsx": 9139,
	"./components/Shapes/1.5/TriangleSmall_15": 44275,
	"./components/Shapes/1.5/TriangleSmall_15.tsx": 44275,
	"./components/Shapes/1.5/Triangle_15": 98960,
	"./components/Shapes/1.5/Triangle_15.tsx": 98960,
	"./components/Shapes/1/CircleSmall_10": 20007,
	"./components/Shapes/1/CircleSmall_10.tsx": 20007,
	"./components/Shapes/1/Circle_10": 99526,
	"./components/Shapes/1/Circle_10.tsx": 99526,
	"./components/Shapes/1/EllipseSmall_10": 3775,
	"./components/Shapes/1/EllipseSmall_10.tsx": 3775,
	"./components/Shapes/1/Ellipse_10": 59038,
	"./components/Shapes/1/Ellipse_10.tsx": 59038,
	"./components/Shapes/1/InvertedTriangleSmall_10": 88956,
	"./components/Shapes/1/InvertedTriangleSmall_10.tsx": 88956,
	"./components/Shapes/1/InvertedTriangle_10": 31243,
	"./components/Shapes/1/InvertedTriangle_10.tsx": 31243,
	"./components/Shapes/1/RectangleSmall_10": 31138,
	"./components/Shapes/1/RectangleSmall_10.tsx": 31138,
	"./components/Shapes/1/Rectangle_10": 9105,
	"./components/Shapes/1/Rectangle_10.tsx": 9105,
	"./components/Shapes/1/RhombusSmall_10": 83345,
	"./components/Shapes/1/RhombusSmall_10.tsx": 83345,
	"./components/Shapes/1/Rhombus_10": 72512,
	"./components/Shapes/1/Rhombus_10.tsx": 72512,
	"./components/Shapes/1/SquareSmall_10": 38810,
	"./components/Shapes/1/SquareSmall_10.tsx": 38810,
	"./components/Shapes/1/Square_10": 3817,
	"./components/Shapes/1/Square_10.tsx": 3817,
	"./components/Shapes/1/TriangleSmall_10": 20347,
	"./components/Shapes/1/TriangleSmall_10.tsx": 20347,
	"./components/Shapes/1/Triangle_10": 24554,
	"./components/Shapes/1/Triangle_10.tsx": 24554,
	"./components/SharePopUp/ISharePopUpParams": 78535,
	"./components/SharePopUp/ISharePopUpParams.tsx": 78535,
	"./components/SharePopUp/SharePopUp": 10635,
	"./components/SharePopUp/SharePopUp.css": 63515,
	"./components/SharePopUp/SharePopUp.tsx": 10635,
	"./components/Stripe": 34430,
	"./components/Stripe.tsx": 34430,
	"./components/StripeWidthList": 18104,
	"./components/StripeWidthList.tsx": 18104,
	"./components/TimerPopUp/ITimerPopUpParams": 22327,
	"./components/TimerPopUp/ITimerPopUpParams.tsx": 22327,
	"./components/TimerPopUp/TimerPopUp": 93612,
	"./components/TimerPopUp/TimerPopUp.css": 84867,
	"./components/TimerPopUp/TimerPopUp.tsx": 93612,
	"./components/Top/Header/Header": 71052,
	"./components/Top/Header/Header.css": 81143,
	"./components/Top/Header/Header.tsx": 71052,
	"./components/Top/Header/IHeaderParams": 46739,
	"./components/Top/Header/IHeaderParams.tsx": 46739,
	"./components/User": 30396,
	"./components/User.tsx": 30396,
	"./components/Vizualization": 53624,
	"./components/Vizualization.tsx": 53624,
	"./components/VizualizationDownload": 81916,
	"./components/VizualizationDownload.tsx": 81916,
	"./components/remoteDownload": 54019,
	"./components/remoteDownload.css": 32938,
	"./components/remoteDownload.tsx": 54019,
	"./externals.d": 23544,
	"./externals.d.ts": 23544,
	"./i18n": 85788,
	"./i18n.ts": 85788,
	"./index": 22974,
	"./index.css": 59555,
	"./index.tsx": 22974,
	"./locales/en": 44174,
	"./locales/en.json": 44174,
	"./locales/es": 46725,
	"./locales/es.json": 46725,
	"./locales/fr": 94605,
	"./locales/fr.json": 94605,
	"./locales/ko": 19423,
	"./locales/ko.json": 19423,
	"./locales/pl": 11029,
	"./locales/pl.json": 11029,
	"./locales/pt": 37741,
	"./locales/pt.json": 37741,
	"./locales/zh": 79527,
	"./locales/zh.json": 79527,
	"./logo.svg": 69445,
	"./react-app-env.d": 55059,
	"./react-app-env.d.ts": 55059,
	"./reportWebVitals": 16469,
	"./reportWebVitals.ts": 16469,
	"./setupTests": 35374,
	"./setupTests.ts": 35374,
	"./utils/IApplicationConfig": 65035,
	"./utils/IApplicationConfig.ts": 65035,
	"./utils/IConfig": 98889,
	"./utils/IConfig.ts": 98889,
	"./utils/IConfigUtils": 36732,
	"./utils/IConfigUtils.test": 28640,
	"./utils/IConfigUtils.test.ts": 28640,
	"./utils/IConfigUtils.ts": 36732,
	"./utils/IEnvironmentConfig": 24448,
	"./utils/IEnvironmentConfig.ts": 24448,
	"./utils/IQueryParamsHelperParams": 74111,
	"./utils/IQueryParamsHelperParams.ts": 74111,
	"./utils/Login.test": 32771,
	"./utils/Login.test.ts": 32771,
	"./utils/StringUtils": 75754,
	"./utils/StringUtils.ts": 75754,
	"./utils/imgUtils": 42606,
	"./utils/imgUtils.ts": 42606,
	"./utils/licenseUtils": 10230,
	"./utils/licenseUtils.test": 21374,
	"./utils/licenseUtils.test.ts": 21374,
	"./utils/licenseUtils.ts": 10230,
	"./utils/polyfills": 79196,
	"./utils/polyfills.ts": 79196,
	"./utils/queryParamsHelper": 17690,
	"./utils/queryParamsHelper.test": 89914,
	"./utils/queryParamsHelper.test.ts": 89914,
	"./utils/queryParamsHelper.ts": 17690,
	"./version": 57902,
	"./version.ts": 57902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;